// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// ASP #9 — one fetch, cached, shared by every CareRx table (E-02: components never call api.* directly).

import { useQuery } from '@tanstack/react-query'
import { listCareRxPatientLanguages } from '../../api/carerxPatient'

export const patientLanguageKeys = { all: ['carerx', 'patient-languages'] as const }

/** patient_id → language display name. A CareRx patient missing from the map has no usable Pioneer language. */
export function useCareRxPatientLanguages() {
  return useQuery({
    queryKey: patientLanguageKeys.all,
    queryFn: async () => new Map((await listCareRxPatientLanguages()).items.map(i => [i.patient_id.toLowerCase(), i.preferred_language])),
    staleTime: 5 * 60_000,
  })
}
